<template>
  <div class="task row justify-content-center">
      <div class="row">
        <div class="col-sm-3">
            <div class="row justify-content-center">
                <h5>Meddelande</h5>
                <div class="input-group margin" v-if="isCreator() || isMember() || isWorkspace()">
                    <input type="text" class="form-control" placeholder="Meddelande" v-model="message">
                    <span class="input-group-btn">
                        <button @click="send" class="btn btn-primary" type="button">Skicka</button>
                    </span>
                </div>
                <div class="row w-100 row-spacing" v-for="(message, index) in task.messages">
                    <b-card
                        show-header
                        show-footer
                        class="w-100"
                        :class="{'incoming': isIncommingMessage(message), 'outgoing': !isIncommingMessage(message)}">
                        <div class="row" slot="header">
                            <div class="col-sm-9">
                                <span>@{{ message.user }}</span>
                            </div>
                            <div class="col-sm-1 mark" v-if="!isRead(message) && isIncommingMessage(message)">
                                <b-button variant="success" @click="markAsRead(message, index)" size="sm"><i class="material-icons">&#xE876;</i></b-button>
                            </div>
                            <div class="col-sm-1 spacing" v-if="!isRead(message) && !isIncommingMessage(message)">
                                <b-badge pill variant="danger">Unread</b-badge>
                            </div>
                        </div>
                        {{ message.message }}
                        <div slot="footer">
                        {{ createdTime(message) }}
                        </div>
                    </b-card>
                </div>
            </div>
        </div>
        <div class="col-sm-9">
        <div class="row">
            <div class="col-sm-7">
                <h5>Uppgift</h5>
                <div class="row justify-content-center">
                    <form v-on:submit.prevent="update" v-if="isCreator() || isWorkspace()">
                            <at-textarea :members="getAutocompleteList()">
                                <textarea class="editor" v-model="content"></textarea>
                            </at-textarea>
                            <button class="btn btn-md btn-primary btn-block" type="submit">Uppdatera</button>
                    </form>
                    <b-card class="w-100 task-box" v-else>
                        <div v-html="task.content_parsed"></div>
                    </b-card>
                </div>
            </div>
            <div class="col-sm-5">
                <div class="row">
                    <h5>Information</h5>
                        <table class="table table-bordered table-striped">
                            <tbody>
                                <tr v-if="task.workarea && (!isCreator() || getWorkareaMembers() > 1)">
                                    <td>Arbetsyta</td>
                                    <td>{{ getAreaName() }}</td>
                                </tr>
                                <tr v-if="task.workarea && isCreator() && getWorkareaMembers() < 2">
                                    <td>Arbetsyta</td>
                                    <td><select class="form-control" v-model="selectedWorkarea">
                                            <option v-for="workarea in workareas" v-bind:key="workarea.id" v-bind:value="workarea">
                                                {{ workarea.name }}
                                            </option>
                                        </select>
                                    </td>
                                </tr>
                                <tr v-if="!task.workarea && isCreator()">
                                    <td>Arbetsyta</td>
                                    <td><select class="form-control" v-model="selectedWorkarea">
                                            <option v-for="workarea in workareas" v-bind:key="workarea.id" v-bind:value="workarea">
                                                {{ workarea.name }}
                                            </option>
                                        </select>
                                    </td>
                                </tr>
                                <tr v-if="task.updated_at">
                                    <td :class="{old: this.old}">Uppdaterad</td>
                                    <td :class="{old: this.old}" v-b-tooltip :title="updatedTimeFull(task)">{{ updatedTime(task) }}</td>
                                </tr>
                                <tr v-if="task.created_at">
                                    <td>Skapad</td>
                                    <td v-b-tooltip :title="createdTimeFull(task)">{{ createdTime(task) }}</td>
                                </tr>
                                <tr>
                                    <td>Skapare</td>
                                    <td>{{ creator(task).username }}</td>
                                </tr>
                                <tr v-if="task.sent_at">
                                    <td>Skickad</td>
                                    <td v-b-tooltip :title="sentTimeFull(task)">{{ sentTime(task) }}</td>
                                </tr>
                                <tr v-if="deadline">
                                    <td>Förfaller</td>
                                    <td><Datetime class="form-control" type="datetime" monday-first auto-continue v-model="deadline"></Datetime></td>
                                </tr>
                                <tr v-else>
                                    <td>Förfaller</td>
                                    <td><button class="btn btn-md btn-outline-success btn-block" type="submit" @click="setDeadline">Sätt</button></td>
                                </tr>
                                <tr v-if="isCreator() || isWorkspace()">
                                    <td>Status</td>
                                    <td>
                                        <b-form-select v-model="selectedStatus" :options="statusOptions" class="mb-3">
                                        </b-form-select>
                                    </td>
                                </tr>
                                <tr v-if="!isCreator() && isMember()">
                                    <td>Delad</td>
                                    <td>
                                        <b-form-select v-model="selectedSharedStatus" :options="sharedStatusOptions" class="mb-3">
                                        </b-form-select>
                                    </td>
                                </tr>
                                <tr>
                                    <td>Max Mottagare</td>
                                    <td><b-form-input v-model="userLimit" type="number"></b-form-input></td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
            </div>
        </div>
        <div class="row userbox">
            <h5>{{ isCreator() ? 'Mottagare' : 'Användare' }}</h5>
            <table class="table table-bordered table-striped">
                <thead>
                    <tr>
                        <th>Användarnamn</th>
                        <th>Status</th>
                        <th>Delad</th>
                        <th>Läst</th>
                        <th>Accepterad</th>
                        <th>Klar/Nekad</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="user in task.users" v-if="!isSelf(user) && showUserInList(user)">
                        <td>{{ user.username }}</td>
                        <td>{{ statusString(user.status) }}</td>
                        <td>{{ sharedStatusString(user.shared_status) }}</td>
                        <td v-b-tooltip :title="formatTimeFull(user.read_at)">{{ formatTime(user.read_at) }}</td>
                        <td v-b-tooltip :title="formatTimeFull(user.accepted_at)">{{ formatTime(user.accepted_at) }}</td>
                        <td v-b-tooltip :title="formatTimeFull(user.finished_at)">{{ formatTime(user.finished_at) }}</td>
                    </tr>
                </tbody>
            </table>
        </div>
        </div>
      </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import helper from '@/utils/helper'
import parser from '@/utils/parser'
import _ from 'lodash'
import marked from 'marked'
import AtTextarea from '@/components/addins/AtTextarea'
import { Datetime } from 'vue-datetime'

marked.setOptions({
    sanitize: true,
    gfm: true,
    breaks: true
})

export default {
    name: 'task',
    components: {
        AtTextarea,
        Datetime
    },
    computed: {
        task () {
            return this.$store.getters.getTask(this.$route.params.id)
        },
        index () {
            return this.$store.state.task.active
        },
        messages () {
            return _.orderBy(this.$store.getters.getTask(this.$route.params.id).messages, ['created_at'], ['desc'])
        },
        markdown () {
            return marked(this.task.content)
        },
        workarea () {
            return _.find(this.$store.state.workarea.workareas, {id: this.task.workarea})
        },
        workareas () {
            return this.$store.state.workarea.workareas
        }
    },
    data () {
        return {
            content: '',
            message: '',
            selectedWorkarea: null,
            simplemde: null,
            statusOptions: [
                {text: 'Öppen', value: 1},
                {text: 'Avslutad', value: 2},
                {text: 'Planerad', value: 3},
                {text: 'Pågående', value: 4},
                {text: 'Avvakta', value: 5},
                {text: 'Klar', value: 6}
            ],
            sharedStatusOptions: [
                {text: 'Nej', value: 0, disabled: true},
                {text: 'Skickad', value: 1, disabled: true},
                {text: 'Mottagen', value: 2, disabled: true},
                {text: 'Läst', value: 3},
                {text: 'Accepterad', value: 4},
                {text: 'Nekad', value: 5},
                {text: 'Klar', value: 6},
                {text: 'Avslutad', value: 7}
            ],
            selectedStatus: 0,
            selectedSharedStatus: 0,
            userLimit: null,
            old: false,
            updatedAt: null,
            deadline: null
        }
    },
    mounted () {
        // Save the updated time
        this.updatedAt = this.task.updated_at

        // Refresh the data for the task
        this.refresh(this.task.id)

        // Set the selected task
        this.select({task: this.task})

        // Set the status
        this.selectedStatus = this.task.status

        // Set the shared status
        this.selectedSharedStatus = this.task.shared_status

        // Check if task has workarea
        if (this.workarea) {
            this.selectedWorkarea = this.workarea
        }

        // Set the deadline
        this.deadline = this.task.deadline
        console.log('Deadline', this.task.deadline, this.deadline)

        // Set the limit
        if (this.task.user_limit !== undefined && this.task.user_limit !== null) {
            this.userLimit = this.task.user_limit.toString()
        }

        // Set the content
        this.content = this.task.content
    },
    watch: {
        task: function () {
            if (this.content !== this.task.content && this.updatedAt !== this.task.updated_at) {
                this.old = true
            }
        },
        selectedStatus: function () {
            if (this.task.status !== this.selectedStatus && this.selectedStatus !== 0) {
                this.updateStatus({task: this.task, status: this.selectedStatus})
            }
        },
        selectedSharedStatus: function () {
            if (this.task.shared_status !== this.selectedSharedStatus && this.selectedSharedStatus !== 0) {
                if (this.selectedSharedStatus === 6) {
                    this.updateStatus({task: this.task, status: 6})
                }

                if (this.selectedSharedStatus === 7 || this.selectedSharedStatus === 5) {
                    this.updateStatus({task: this.task, status: 2})
                }

                this.updateSharedStatus({task: this.task, status: this.selectedSharedStatus})
            }
        }
    },
    methods: {
        ...mapActions({
            refresh: 'task_get',
            insert: 'task_put',
            insertMessage: 'task_message',
            updateStatus: 'task_status',
            updateSharedStatus: 'task_shared_status',
            select: 'task_select',
            markMessageRead: 'task_message_read'
        }),
        ...mapGetters({
            getFriends: 'getFriendsList'
        }),
        createdTime: helper.task.getCreatedTime,
        updatedTime: helper.task.getUpdatedTime,
        createdTimeFull: helper.task.getCreatedTimeFull,
        updatedTimeFull: helper.task.getUpdatedTimeFull,
        sentTime: helper.task.getSentTime,
        sentTimeFull: helper.task.getSentTimeFull,
        formatTime: helper.task.formatTime,
        formatTimeFull: helper.task.formatTimeFull,
        creator: helper.task.getCreator,
        statusString: helper.status.toString,
        sharedStatusString: helper.sharedStatus.toString,
        isCreator: function () {
            return this.$store.state.authentication.user.id === this.task.creator
        },
        getAutocompleteList: function () {
            // Get both groups and friends
            let friend = this.getFriends()
            let groups = this.$store.state.group.groups

            // Add '@' infront of all group names and extract the names
            groups = _.map(groups, g => '@' + g.name)

            // Return the array
            return _.concat(friend, groups)
        },
        isIncommingMessage: function (message) {
            return helper.task.isIncommingMessage(this.task, this.$store.state.authentication.user, message, this.$store.state.workarea.workareas)
        },
        showUserInList: function (user) {
            if (!this.isMember(user) && this.task.creator === user.user) {
                return false
            }

            return true
        },
        isSelf: function (user) {
            return user.user === this.$store.state.authentication.user.id
        },
        isMember: function () {
            return _.find(this.task.users, {user: this.$store.state.authentication.user.id}) !== undefined
        },
        isWorkspace: function (task) {
            return _.find(this.$store.state.workarea.workareas, {id: this.task.workarea}) !== undefined
        },
        getAreaName: function () {
            if (this.workarea) {
                return this.workarea.name
            }

            return 'Ingen'
        },
        update: function () {
            // Parse the updated content
            var task = parser.parse(this, this.content, null, this.userLimit, (this.task.user_limit !== null && this.task.user_limit !== undefined && this.task.user_limit > 0))

            // Set the correct id
            task.id = this.task.id

            // Set the deadline for the task
            task.deadline = this.deadline

            // Check if the selectedWorkarea has been changed
            if (this.selectedWorkarea !== null && task.workarea !== this.selectedWorkarea.id) {
                // Set the new workarea
                task.workarea = this.selectedWorkarea.id
            }

            // Insert the new task
            this.insert({task, back: true})
        },
        send: function () {
            if (this.message === '' || this.message === null) {
                return
            }

            // Send the message
            this.insertMessage({task: this.task, message: this.message})

            // Empty the textbox
            this.message = ''
        },
        changed: function (event) {
            this.content = event.target.textContent
        },
        resetEditor: function () {
            this.content = ''
        },
        markAsRead: function (message, index) {
            this.markMessageRead({task: this.task, message, index, user: this.$store.state.authentication.user})
        },
        isRead: function (message) {
            return message.acknowledged_by !== null && message.acknowledged_by !== undefined
        },
        shouldShowReadStatus: function (message) {
            if (message.user === this.$store.state.authentication.user.username) {
                return false
            }

            return true
        },
        setDeadline: function () {
            this.deadline = new Date().toLocaleString()
            console.log(this.deadline)
        },
        getWorkareaMembers: function () {
            if (this.workarea) {
                return this.workarea.members.length
            }

            return 0
        }
    }
}
</script>

<style lang="scss">
    .margin {
        margin-bottom: 1rem;
    }

    .task-box {
        margin-left: 1rem;
        margin-right: 1rem;
    }

    div.row-spacing {
        margin-bottom: 1rem;
    }

    div.userbox {
        padding: 1rem;
    }

    textarea.editor {
        width: 28rem;
        height: 25rem;
        border: 1px solid #95a5a6;
        margin-bottom: 1rem;
        padding: 0.5rem;
    }

    div.mark {
        padding-right: 0px;
        padding-bottom: 0px;
        padding-top: 0px;
        background-color: #f39c12;
    }

    div.spacing {
        padding: 0;
    }

    .incoming {
        .card-header, .card-footer {
            background-color: #f39c12;
            color: #ecf0f1;
        }
    }

    .outgoing {
        .card-header, .card-footer {
            background-color: #1abc9c;
            color: #ecf0f1;
        }
    }

    .old {
        background-color: #f39c12;
        color: #ecf0f1;
    }

    .vdatetime {
        input {
            border: none;
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/Task.vue